import * as $ from 'jquery';
import 'bootstrap';
import {bookingFormCommon} from './c005-bookingform-common';
import { wcagOptions } from "./wcag";

export class milesCalculatorForms{
	private wcag = new wcagOptions();
	private $viewBookingError:Array<string> = [];
	private bcommon = new bookingFormCommon();

	$scope: any = $('#view-booking--container');
    $scopeMob: any = $('#mob-viewbooking--container');

    /**
	 * @function initSelectize
	 * @param  {any} listItems [description]
	 * @return {any}           [description]
	 * !!! Properly scoped
	 */
    initSelectize(listItems: any): void {
        let _self = this;
        let $fhToLocationContainer: any = $('.miles-calculator--widget');
        let $fhDepDateContainer: any = $('#depDate');
        let $fhFromLocation: any = $('.from--location');
        let $fhFromSelectize: any;
        let $fromLocationSelectizeInput:any = $fhFromLocation.parent().find('.selectize-control .selectize-input');
        let $fhToLocation: any = $('.to--location');
        let $fhToSelectize: any;
        $('.miles-table').hide();
        $fhFromLocation.html(listItems);
        $fhFromLocation.selectize({
            onInitialize: function () {
                $fhFromSelectize = $($fhFromLocation[0].selectize.$control[0]);
            },
            onFocus: function () {
                $fromLocationSelectizeInput.removeClass('has-error');
                
            },
            onChange: function (value: any) {
                if ($fhFromLocation.val() != '') {
                    $fhFromLocation.find('input[type="select-one"]').focus();
                    $fhFromLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
                _self.bcommon.updateRevenueOnDListOnFlowChange("redemption", $fhFromLocation.val().trim(), $fhToLocation);
                },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Departure',
            selectOnTab: true
        });
        $('.from--location').data('selectize').setValue("KUL");
        $fhToLocation.html(listItems);
        $fhToLocation.selectize({
            onInitialize: function () {
                $fhToSelectize = $($fhToLocation[0].selectize.$control[0]);
            },
            onFocus: function () {

            },
            onChange: function (value: any) {
                if ($fhToLocation.val() != '') {
                    
                   // $fhToLocation.parent().find('.selectize-control .selectize-input').removeClass('has-error');
                }
            },
            onBlur: function (data: any) {
            },
            onLoad: function (data: any) {
            },
            lockOptgroupOrder: true,
            searchField: ['text', 'optgroup'],
            placeholder: 'Destination',
            selectOnTab: true
        });

        $(".from--location").keydown(function (event: any) {
            if (event.keyCode === 9) {
                event.preventDefault();
                event.stopPropagation();
            }
        });
    }
	formValidation($instance:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];

		let $errorValidation = $instance.find('.miles-error-validation').first();
		let formDataValid = true;

		let $fromLocation:any     = $instance.find('.from--location'),
			$fromBookingTitle:any = $fromLocation.parent().find('.booking-form--title'),
			$fromSelectize:any    = $fromLocation.parent().find('.selectize-control .selectize-input');

		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		// Validation: IBE From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			$fromBookingTitle.addClass('has-error');
			let $fromLocValidate:any = $fromLocation.attr('data-from-error');
			$errorList.push('<strong>'+$fromLocation.parent().text()+':</strong> '+$fromLocValidate);
			formDataValid = false;
		} else {
			$fromSelectize.removeClass('has-error');
			$fromBookingTitle.removeClass('has-error');
		}

		let $toLocation:any     = $instance.find('.to--location'),
			$toBookingTitle:any = $toLocation.parent().find('.booking-form--title'),
			$toSelectize:any    = $toLocation.parent().find('.selectize-control .selectize-input');

		// Validation: IBE To Location empty field
		if ($toLocation.val() == '') {
			$toSelectize.addClass('has-error');
			$toBookingTitle.addClass('has-error');

			let $toLocValidate:any = $toLocation.attr('data-to-error');
			$errorList.push('<strong>'+$toLocation.parent().text()+':</strong> '+$toLocValidate);
			formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
			$toBookingTitle.removeClass('has-error');
		}

		// Validation: IBE From/To Location identical value
		if ($fromLocation.val() === $toLocation.val()) {
			$toSelectize.addClass('has-error');
			$toBookingTitle.addClass('has-error');
			formDataValid = false;

			if (!($fromLocation.val() == '' || $toLocation.val() == '')){
				let $fromLoLocValidate:any = $fromLocation.attr('data-from-to-error');
				 $errorList.push($fromLoLocValidate);
			}
		}

		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback();
			}
		} else {
			return false;
		}
	}
	getRevenuewOND(): void {
        let _self = this;
        let $instance: any = $('.miles-calculator--widget');
        let $fromLocation:any     = $instance.find('.from--location').val();
		let $toLocation:any     = $instance.find('.to--location').val();
        if(window.location.hostname == "localhost" && window.location.port == "5000"){
       //let response:any = {"milesList":[{"Platinum":[],"Gold":[],"Silver":[],"Blue":[]}]};
            let response:any = {"milesList":[{"Platinum":[{"miles":"236","cabinClass":"Economy"},{"miles":"1508","cabinClass":"Business"},{"miles":"1649","cabinClass":"Business Suite"}],"Gold":[{"miles":"245","cabinClass":"Economy"},{"miles":"1568","cabinClass":"Business"},{"miles":"1715","cabinClass":"Business Suite"}],"Silver":[{"miles":"189","cabinClass":"Economy"},{"miles":"1206","cabinClass":"Business"},{"miles":"1320","cabinClass":"Business Suite"}],"Blue":[{"miles":"254","cabinClass":"Economy"},{"miles":"1629","cabinClass":"Business"},{"miles":"1781","cabinClass":"Business Suite"}]}]};
            _self.displayMiles(response);
        }else{
            $.ajax({
                type: 'GET',
                url: '/bin/services/new/earnmiles?origin='+$fromLocation+'&destination='+$toLocation,
                success: function(json:any) {
                    json = JSON.parse(json);
                    _self.displayMiles(json);
                },
                error: function(error:any) {
                    console.log("Error while getting member info", error);
                }
            });		
        }	
    }

    /* Display earnrich miles table */
	displayMiles(response:any): void {
		let _self = this;
        let $milesHtlml: any;
        var responselist =response.milesList ;
        if(responselist[0].Platinum.length == 0){
           $milesHtlml +=   '<tr>'
           +'<td align= "center" colspan="5">No record found</td>'
           + '</tr>';
        }else{
               var j=0, i=0;
               $.each(responselist[i], function (key:any, value:any) { 
                 if(j<3){
                       $milesHtlml +=   '<tr>'
                                         +'<td class="expiring-miles">'+responselist[i][key][j].cabinClass+' </td>'  
                                         +'<td class="month-1">'+responselist[i]['Platinum'][j].miles+'</td>'
                                         + '<td class="month-2">'+responselist[i]['Gold'][j].miles+'</td>'
                                         + '<td class="month-3">'+responselist[i]['Silver'][j].miles+'</td>'
                                         + '<td class="month-3">'+responselist[i]['Blue'][j].miles+'</td>'
                                         + '</tr>';
                 }
                 j++;
               });
        }    
        $('.miles-data-display').html($milesHtlml);
        $('.miles-table').show();
	}
 
    /**
	 * @function searchHandler
	 * !!! Properly scoped
	 */
	searchHandler(): void {
		let _self = this;

        let $submitBtn:any    = $('.miles-calculator-btn');
        let $locationContainer: any = $('.miles-calculator--widget');
        let $errorValidation = $('.miles-error-validation').first();
        $('.miles-table').hide();
			$submitBtn.on('click', (evt:any) => {
                $errorValidation.show();
				_self.formValidation($locationContainer, function(){
                    _self.getRevenuewOND();
                });
              //  _self.formValidation($locationContainer);

			});
	}


}

let scope:Element = document.querySelector('.miles-calculator--widget');
if (scope){
	try {
        let milesCalculatorForm = new milesCalculatorForms();
        let bookingformcommon = new bookingFormCommon();
        window['revenueOND'] = $.Deferred();
        bookingformcommon.revenueOND().done((listData: any) => {
            window['revenueOND'].resolve(listData);
        });
        window['revenueOND'].promise();
        $.when(window['revenueOND']).done((listData: any) => {
        let listItems:string = bookingformcommon.parseOnDListItems(listData, 'redemption');
        milesCalculatorForm.initSelectize(listItems);
        });
        milesCalculatorForm.searchHandler();
        //milesCalculatorForm.getRevenuewOND();
	} catch(e) {console.error(e);}
}